import Styles from './PlaceholderRightRail.module.scss'
import { PlaceHolderButton } from 'blaze-components/WriterTopBar/WriterTopBar'
import { Card } from 'components/DocRightRail/screens/AIAssistant/Card'

export const PlaceholderRightRail = () => (
  <div className={Styles.root} data-theme="light">
    <div className={Styles.heading}>
      <PlaceHolderButton />
      <PlaceHolderButton />
      <PlaceHolderButton />
    </div>
    <div className={Styles.body}>
      <Card className={Styles.card} />
      <Card className={Styles.card} />
      <Card className={Styles.card} />
      <Card className={Styles.card} />
      <Card className={Styles.card} />
      <Card className={Styles.card} />
    </div>
  </div>
)
